import { isBrowser } from '@/services/Utilities/Runtime';

let checkBrowserTranslationImpl: () => string | null = () => null;
if (isBrowser) {
    // Detection Reference https://martijnhols.nl/gists/how-to-detect-google-translate-and-other-machine-translation
    // Stripped down to only detect translation at the time this function is called.
    // This doesn't remember if the user used translation, then reverted back, before calling this function
    const originalHtmlLang = document.documentElement.lang;
    checkBrowserTranslationImpl = () => {
        if (document.documentElement.className.match('translated')) {
            // Sometimes Chrome don't change lang element or Chrome's change got reverted by something else
            return `Chrome translate to ${document.documentElement.lang}`;
        }
        if (document.querySelector('[_msttexthash]')) {
            return 'MS Edge';
        }
        if (document.documentElement.lang !== originalHtmlLang) {
            // Such as Firefox
            // Chrome, when reverting, sometimes lang change back to 'en' instead of original 'en-US'
            return `HTML lang element changed "${originalHtmlLang}" to "${document.documentElement.lang}"`;
        }
        return null;
    };
}

export const detectBrowserTranslation = checkBrowserTranslationImpl;

// Some react errors can occur from browser Translator messing with React-controlled DOM
// See https://martijnhols.nl/gists/everything-about-google-translate-crashing-react
export const isAffectedReactError = (errorMessage: string) =>
    ['insertBefore', 'removeChild'].some((v) => errorMessage.includes(v));
